export function separatorJoin(objArray, separator) {
  return objArray.reduce((a, b) => {
    if (!a.length) return [b];
    return [...a, separator, b];
  }, [])
}



// WEBPACK FOOTER //
// ./src/components/Boilerplate/utilities.js